import "./OptionContractComponent.scss";
import template from "./OptionContractComponent.html";
import {IComponentOptions} from "angular";
import {OptionRecord} from "../../models/OptionChainRecord";
import {AsxInstrumentUtil} from "../../../../js/util/asx/AsxInstrumentUtil";

export const OptionContract = "tfOptionContract";

export function optionContract(): IComponentOptions {
    return {
        template,
        bindings: {
            option: "<"
        },
        controllerAs: "ctrl",
        controller: OptionContractComponentController
    };
}

export class OptionContractComponentController {

    /** @input */
    public readonly option: OptionRecord | null;

    public get isIndex(): boolean {
        if (this.option == null) {
            return false;
        } else {
            return AsxInstrumentUtil.isIndex(this.option.underlying.code);
        }
    }
}
